import React, { forwardRef } from "react";
import { FaCalendarAlt } from "react-icons/fa";

const CalendarInput = forwardRef(({ value, onClick }, ref) => (
  <div className="position-relative w-80">
    {/* Input */}
    <input
      ref={ref}
      value={value}
      onClick={onClick}
      readOnly
      className="form-control"
      // style={{ paddingRight: "10px" }} 
    />

    {/* Icon */}
    <FaCalendarAlt
      size={18}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        color: "#6c757d",
        pointerEvents: "none",
      }}
    />
  </div>
));

export default CalendarInput;
